$(document).ready(function(){
	init(); 
});

$(window).resize(function() {
  resize();
});

$(window).on('load', function() {
  window_load();
});

function apprenticeship_form_submit() {
  
  $('#apprenticeshipForm').submit(function() {
    $('.w-form-fail').hide();
    $('.w-form-done').hide();

    var hasError = false;
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var nameReg = /^[\x00-\x7F]{3,32}$/;
    var numberonly = /^[0-9\s]{1,40}$/;
    var urlReg = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    var name = $("#name").val();
    if (name == '') {
      console.log("Error: Please enter your Name.");
      $("#name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Name.</div>');
      hasError = true;
    } else if (!nameReg.test(name)) {
      console.log("Error: Enter a valid Name.");
      $("#name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Name.</div>');
      hasError = true;
    }

    var surname = $("#surname").val();
    if (surname == '') {
      console.log("Error: Please enter your Surname.");
      $("#surname").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Surname.</div>');
      hasError = true;
    } else if (!nameReg.test(surname)) {
      console.log("Error: Enter a valid Surname.");
      $("#surname").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Surname.</div>');
      hasError = true;
    }

    var telephone = $("#telephone").val();
    if (telephone == '') {
      console.log("Error: Please enter your Telephone Number.");
      $("#telephone").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Telephone Number.</div>');
      hasError = true;
    } else if (!numberonly.test(telephone)) {
      console.log("Error: Enter a valid Telephone Number.");
      $("#telephone").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Telephone Number.</div>');
      hasError = true; 
    }

    var email = $("#email").val();
    if (email == '') {
      console.log("Error: Please enter your Email Address.");
      $("#email").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');
      hasError = true;
    } else if (!emailReg.test(email)) {
      console.log("Error: Enter a valid Email Address.");
      $("#email").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');
      hasError = true;
    }

    var message = $("#message").val();

    if (hasError == true) {
      return false; //stop html submit

    } else {

      jQuery.ajax({
        type : 'post',
        url : '/wp-admin/admin-ajax.php',
        data : {
          action : 'send_mail',
          name : name,
          surname : surname,
          telephone : telephone,
          email : email,
          message : message,
        },
        success : function( response ) {
          $('#apprenticeshipForm').hide();
          $('.w-form-done').show();
        },
      });
      return false; //stop html submit
    }
  });
}

function booking_widget() {

  Mxm.Tracker.setAutoLinkDomains([
    '<?php echo $DD_domain; ?>',
    'bluebirdrestaurant.danddbookings.com',
    'bluebirdafternoontea.danddbookings.com',
    'butlerswharfchophouse.danddbookings.com',
    'butlerswharfchophousebarandgrill.danddbookings.com',
    'plateaurestaurant.danddbookings.com',
    'plateaubarandgrill.danddbookings.com',
    'skylon.danddbookings.com',
    'skylongrill.danddbookings.com',
    'coqdargent.danddbookings.com',
    'thegrillcda.danddbookings.com',
    'lepontdelatour.danddbookings.com',
    'lepontdelatourbarandgrill.danddbookings.com',
    'royalexchange.danddbookings.com',
    'restaurantsauterelle.danddbookings.com',
    'quaglinos.danddbookings.com',
    'quaglinosbar.danddbookings.com',
    'floridita.danddbookings.com',
    'madison.danddbookings.com',
    'kensingtonplace.danddbookings.com',
    'caromatmeza.danddbookings.com',
    'quaglinos.danddbookings.com',
    'quaglinosbar.danddbookings.com',
    'fishmarket.danddbookings.com',
    'cantinadelponte.danddbookings.com',
    'paternosterchophouse.danddbookings.com',
    'almeida.danddbookings.com',
    'avenuerestaurant.danddbookings.com',
    'launcestonplace.danddbookings.com',
    'orrery.danddbookings.com',
    'angler.danddbookings.com',
    'newstreetgrill.danddbookings.com',
    'sartoria.danddbookings.com',
    'crafthouse.danddbookings.com'
  ]);
  Mxm.Tracker.setAutoLink(true);

  $('#bookform #submit').click(function(e) { 

    submitURL = $('#reservation_rid').attr("data-action");

    switch(submitURL) {
      case 'https://orrery.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=80029&restref=80029', '_blank');
        break;
      case 'https://asterrestaurant.danddbookings.com/':
        window.open('https://www.sevenrooms.com/reservations/asterupstairs?venues=asterupstairs,asterlondon', '_blank');
        break;
      case 'https://bluebirdcafe.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=134214&restref=134214', '_blank');
        break;
      case 'https://quaglinos.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=81343&restref=81343', '_blank');
        break;
      case 'https://quaglinosbar.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=95622&restref=95622', '_blank');
        break;
      case 'https://skylon.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=82351&restref=82351', '_blank');
        break;
      case 'https://cantinadelponte.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=80524&restref=80524', '_blank');
        break;
      case 'https://blueprintcafe.danddbookings.com':
        window.open('https://www.sevenrooms.com/reservations/blueprintcafe', '_blank');
        break;
      case 'https://lepontdelatour.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=80512&restref=80512', '_blank');
        break;
      case 'https://lepontdelatourbarandgrill.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=81745&restref=81745', '_blank');
        break;
      case 'https://butlerswharfchophouse.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=80614&restref=80614', '_blank');
        break;
      case 'https://fishmarket.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=92280&restref=92280', '_blank');
        break;
      case 'https://coqdargent.danddbookings.com':
        window.open('https://www.opentable.co.uk/coq-dargent-restaurant', '_blank');
        break;
      case 'https://thegrillcda.danddbookings.com':
        window.open('https://www.sevenrooms.com/reservations/coqdargentgrill', '_blank');
        break;
      case 'https://haugen.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=257934&restref=257934', '_blank');
        break;
      case 'https://angler.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=92148&restref=92148', '_blank');
        break;
      case 'https://launcestonplace.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=78703&restref=78703', '_blank');
        break;
      case 'https://newstreetgrill.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=92265&restref=92265', '_blank');
        break;
      case 'https://southplacechophouse.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=92145&restref=92145', '_blank');
        break;
      case 'https://fiume.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=142071&restref=142071', '_blank');
        break;
      case 'https://bluebirdrestaurant.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=80812&restref=80812', '_blank');
        break;
      case 'https://bluebirdafternoontea.danddbookings.com':
        window.open('https://www.sevenrooms.com/reservations/bluebirdchelsearestaurant?venues=bluebirdchelseacafe,bluebirdchelsearestaurant,bluebirdchelseapdr', '_blank');
        break;
      case 'https://bluebirdcafewhitecity.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=143784&restref=143784', '_blank');
        break;        
      case 'https://sartoria.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=82411&restref=82411', '_blank');
        break;
      case 'https://avenuerestaurant.danddbookings.com':
        window.open('https://www.sevenrooms.com/reservations/avenuelondon', '_blank');
        break;
      case 'https://100wardourclub.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=75727&restref=75727', '_blank');
        break;
      case 'https://100wardourlounge.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=75730&restref=75730', '_blank');
        break;
      case 'https://issholeeds.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=138378&restref=138378', '_blank');
        break;
      case 'https://east.danddbookings.com/':
        window.open('https://www.sevenrooms.com/reservations/east59th', '_blank');
        break;
      case 'https://radici.danddbookings.com/':
        window.open('https://www.sevenrooms.com/reservations/radici', '_blank');
        break;
      case 'https://germangymnasium.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=116772&restref=116772', '_blank');
        break;
      case 'https://germangymnasiumcafe.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=117417&restref=117417', '_blank');
        break; 
      case 'https://angelica.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=95550&restref=95550', '_blank');
        break;
      case 'https://crafthouse.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=95544&restref=95544', '_blank');
        break;   
      case 'https://orelle.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=285084&restref=285084', '_blank');
        break; 
      case 'https://paternosterchophouse.danddbookings.com':
        window.open('https://www.opentable.co.uk/paternoster-chop-house', '_blank');
        break; 
      case 'https://madison.danddbookings.com/':
        window.open('https://www.opentable.com/restref/client/?rid=62221&restref=62221', '_blank');
        break;
      case 'https://20storiesres.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=143787&restref=143787', '_blank');
        break;
      case 'https://plateaurestaurant.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=80929&restref=80929', '_blank');
        break;
      case 'https://plateaubarandgrill.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=82360&restref=82360', '_blank');
        break;
      case 'https://oldbengalbar.danddbookings.com':
        window.open('https://www.opentable.com/restref/client/?rid=92274&restref=92274', '_blank');
        break;      
      default:

      if (Mxm && Mxm.Tracker) {
        submitURL += '?' + Mxm.Tracker.getQueryKey() + '=' + Mxm.Tracker.getRoiCode();
      }

      var party_size = $('input[name="reservation_partysize"]').val(),
          location = $('input[name="reservation_rid"]').val(),
          time = $('input[name="reservation_sitting"]').val();

      if(party_size === '') {
        $('.reservation_partysize').html('Please pick a number');
        $('.reservation_partysize').addClass('error');
        party_size_success = false;
      } else {
        $('.reservation_partysize').removeClass('error');
        party_size_success = true;
      }

      if(location === '') {
        $('.location').html('Please pick a restaurant');
        $('.location').addClass('error');
        location_success = false;
      } else {
        $('.location').removeClass('error');
        location_success = true;
      }

      if(time === '') {
        $('.reservation_sitting').html('Please pick a time');
        $('.reservation_sitting').addClass('error');
        time_success = false;
      } else {
        $('.reservation_sitting').removeClass('error');
        time_success = true;
      }

      if(party_size_success === true && location_success === true && time_success === true) {
        $('#bookform').get(0).setAttribute('action', submitURL);
        $('#bookform').submit();
      }
    }
  });
         
  $('#reservation_datetime_date').datepicker({
    //showOn      : 'button',
    duration    : 'fast',
    buttonImageOnly : false,
    minDate     : 'now',
    maxDate     : 'now + 12 months',
    dateFormat    : 'yy-mm-dd',
    onSelect    : function(dateText, widget) {
      var date = $.datepicker.parseDate('yy-mm-dd', dateText);
      $('#reservation_display').val($.datepicker.formatDate('dd/mm/yy', date));
    }
  }).datepicker( "setDate" ,new Date());

  $('.ui-datepicker-trigger').click(function(e) {
    $('#reservation_datetime_date').datepicker('show');
    if($(window).width() > 500) {
      $('#ui-datepicker-div').css('top', '263px');
    } else {
      $('#ui-datepicker-div').css('top', '208px');
    }
  });
}

function booking_widget_toggle() {

  $('.book-a-table').click(function() {
    $('.c__booking-widget').addClass('active');
  });

  $('#close-widget').click(function() {
    $('.c__booking-widget').removeClass('active');
  });
}

// This function is used for the smooth scrolling
function calculate_body_height() {

  var height = $('#scroll-container').outerHeight(true);

  $('body').css('height', height);
}

function clickable_block() {

  $('.clickable-block').click(function() {
    $(this).find('a')[0].click();
  });
}

function competition_signup() {
    $('#entryform').submit(function(e) { // called by click, on auto submit or enter key

    $(".error").hide(); 
            
    var hasError = false;     
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/; 
    var nameReg = /^[\x00-\x7F]{3,32}$/;
    var numberonly = /^[0-9\s]{1,40}$/;
    var urlReg =  /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    var email = $("#email_address").val();        
    if(email == '') {       
      $("#email_address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');            
      hasError = true;        
    }         
    else if(!emailReg.test(email)) {            
      $("#email_address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');            
      hasError = true;        
    }   

    var first_name = $("#first_name").val();        
    if(first_name == '') {       
      $("#first_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');            
      hasError = true;        
    }         
    else if(!nameReg.test(first_name)) {            
      $("#first_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');            
      hasError = true;        
    }   

    var last_name = $("#last_name").val();        
    if(last_name == '') {       
      $("#last_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');            
      hasError = true;        
    }         
    else if(!nameReg.test(last_name)) {            
      $("#last_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');            
      hasError = true;        
    }   

    //gdpr
    if(document.getElementById('gdpr1').checked) {
      //do nothing
    } else {
      $("#gdpr1").after('<div class="error w-col w-col-12" style="padding-left: 40px; font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please tick to accept our privacy policy.</div>');            
      hasError = true;        
    }
    
    // if(document.getElementById('gdpr2').checked) {
    //   //do nothing
    // } else {
    //   $("#gdpr2").after('<div class="error w-col w-col-12" style="padding-left: 40px; font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please tick to receive newsletters.</div>');            
    //   hasError = true;        
    // }           
            
    var captcha = grecaptcha.getResponse();
    var url = 'https://www.danddlondon.com/wp-content/themes/brandstyle1/recaptcha/check.php'; 
        
    if (captcha.length == 0 ) { 
      $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Complete the CAPTCHA.</div>'); 
      hasError = true; 
    } else if(hasError == false){// only check if validation is success to this point
      //whatever happens next -- need to always return false
      hasError = true; 
        
      $.ajax({
        url: url + "?captcha="+captcha,
        type: "POST",
        //data: (post_data),
        success: function (res) {
          if(res == 'error:captcha') {
            console.log('captcha failed');
            $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Captcha Failed. Try Again.</div>'); 
            hasError = true; 
          }
            
          if(res == 'error:secret key missing') {
            console.log('captcha failed - key missing');
            $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Captcha Failed. Key Missing.</div>'); 
            hasError = true; 
          }             
            
          if(res == 'success:captcha') {
            //disable submit button
            $('#submittrigger').attr('disabled','disabled');
              
            actionURL = $('#entryform').attr('data-action');
            $('#g-recaptcha-response').remove(); //kill the response from Google so it's not sent to Maxemail
            submitdata = $('#entryform').serialize();

            $.ajax({
              url: actionURL,
              type: "POST",
              contentType: 'application/x-www-form-urlencoded', 
              crossDomain: true,
              data: (submitdata),
              complete: function(xmlHttp) {
                // response is 302 so can't pick up on that in JS
              },//complete
              error: function(xmlHttp) {
                // xmlHttp is a XMLHttpRquest object
                // response is 302 so can't pick up on that in JS
                // have to assume all is ok and display a thanks message
                $('#entryform').html('<p>Thank you for entering our competition. We will be in touch shortly!</p>');
                calculate_body_height();
                $('html, body').animate({
                  scrollTop: $('.m__competition-entry-form').offset().top - 200
                }, 500);
              }//complete                     
            });//ajax (second submit) 
                        
            //although there's no error returns false so HTML doesn't try and submit after JS triggered submit
            hasError = true; 
          }
        },//else error
        error : function(XMLHttpRequest, textStatus, errorThrown) {
          //alert("error: "+errorThrown, 0, "Error", "Error");
          console.log("error: "+errorThrown, 0, "Error", "Error");  
          hasError = true;                        
        }
      });//ajax 
    }//if captcha is not empty
  
    // Final test
    if(hasError == true) { 
      return false; //stop html submit
    }else{
      //do nothing and let html submit
    } // end if
  }); // submit form    
}

function book_club_signup() {
  $('#bookclubsignup').submit(function(e) { // called by click, on auto submit or enter key

    $(".error").hide();

    var hasError = false;
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var nameReg = /^[\x00-\x7F]{3,32}$/;
    var numberonly = /^[0-9\s]{1,40}$/;
    var urlReg =  /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    var email = $("#work_email_address").val();
    $("input[name=email_address]").val(email);
    if(email == '') {
      $("#work_email_address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');
      hasError = true;
    }
    else if(!emailReg.test(email)) {
      $("#work_email_address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');
      hasError = true;
    }

    var first_name = $("#first_name").val();
    if(first_name == '') {
      $("#first_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your First Name</div>');
      hasError = true;
    }
    else if(!nameReg.test(first_name)) {
      $("#first_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid First Name.</div>');
      hasError = true;
    }

    var last_name = $("#last_name").val();
    if(last_name == '') {
      $("#last_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Last Name</div>');
      hasError = true;
    }
    else if(!nameReg.test(last_name)) {
      $("#last_name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Last Name.</div>');
      hasError = true;
    }

    //gdpr
    if(document.getElementById('gdpr1').checked) {
      //do nothing
    } else {
      $("#gdpr1").after('<div class="error w-col w-col-12" style="padding-left: 40px; font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please tick to accept our privacy policy.</div>');
      hasError = true;
    }

    var captcha = grecaptcha.getResponse();
    var url = 'https://www.danddlondon.com/wp-content/themes/brandstyle1/recaptcha/check.php';

    if (captcha.length == 0 ) {
      $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Complete the CAPTCHA.</div>');
      hasError = true;
    } else if(hasError == false){// only check if validation is success to this point
      //whatever happens next -- need to always return false
      hasError = true;

      $.ajax({
        url: url + "?captcha="+captcha,
        type: "POST",
        //data: (post_data),
        success: function (res) {
          if(res == 'error:captcha') {
            console.log('captcha failed');
            $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Captcha Failed. Try Again.</div>');
            hasError = true;
          }

          if(res == 'error:secret key missing') {
            console.log('captcha failed - key missing');
            $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Captcha Failed. Key Missing.</div>');
            hasError = true;
          }

          if(res == 'success:captcha') {
            //disable submit button
            $('#submittrigger').attr('disabled','disabled');

            actionURL = $('#bookclubsignup').attr('data-action');
            $('#g-recaptcha-response').remove(); //kill the response from Google so it's not sent to Maxemail
            submitdata = $('#bookclubsignup').serialize();

            $.ajax({
              url: actionURL,
              type: "POST",
              contentType: 'application/x-www-form-urlencoded',
              crossDomain: true,
              data: (submitdata),
              complete: function(xmlHttp) {
                // response is 302 so can't pick up on that in JS
              },//complete
              error: function(xmlHttp) {
                // xmlHttp is a XMLHttpRquest object
                // response is 302 so can't pick up on that in JS
                // have to assume all is ok and display a thanks message
                $('#bookclubsignup').html('<p>Thank you for signing up and submitting your preferences!</p>');
                calculate_body_height();
                $('html, body').animate({
                  scrollTop: $('.m__competition-entry-form').offset().top - 200
                }, 500);
              }//complete
            });//ajax (second submit)
            var url = '/wp-content/themes/brandstyle1/mail/send.php';
            var datastring = $("#bookclubsignup").serialize();
            $.ajax({
              type: 'POST',
              url: url,
              data: datastring,
              success: function (data) {
                console.log(data);
              }, //else error
            });// end ajax read
            //although there's no error returns false so HTML doesn't try and submit after JS triggered submit
            hasError = true;
          }
        },//else error
        error : function(XMLHttpRequest, textStatus, errorThrown) {
          //alert("error: "+errorThrown, 0, "Error", "Error");
          console.log("error: "+errorThrown, 0, "Error", "Error");
          hasError = true;
        }
      });//ajax
    }//if captcha is not empty

    // Final test
    if(hasError == true) {
      return false; //stop html submit
    }else{
      //do nothing and let html submit
    } // end if
  }); // submit form
}

function form_accordion() {

  $('.m__enquiry-form #open-form').click(function() {
    $(this).addClass('disable');
    $('.m__enquiry-form form').slideToggle(function() {
      calculate_body_height();
    });
  });
}

function header_switch() {

  var window_width = $(window).width();

  /*if(window_width < 950) {
    $('.home .c__header').addClass('solid');
    $('.home .c__header').removeClass('transparent');
  } else {
    $('.home .c__header').addClass('transparent');
    $('.home .c__header').removeClass('solid');
  }*/
}

// If wp admin bar is present move the header down
function header_adjust() {

  var window_width = $(window).width();

  if($('#wpadminbar').length) {
    if(window_width >= 782) {
      $('header').css('top', '32px');
      $('.header-spacer').css('margin-top', '32px');
    } else {
      $('header').css('top', '46px');
      $('.header-spacer').css('margin-top', '46px');
    }
  }
}

function homepage_header_transition() {

  var distance_top = $(window).scrollTop();

  var window_width = $(window).width();

  var window_height = $(window).height() / 4;

    if(window_width >= 950) {

      /*if (distance_top >= window_height) {
        $('.home header').addClass("solid");
      } else {
        $('.home header').removeClass("solid");
      }*/

      $(window).scroll(function() {    
        
        var scroll = $(window).scrollTop();

        /*if (scroll >= window_height) {
          $('.home header').addClass("solid");
        } else {
          $('.home header').removeClass("solid");
        }*/
      });
    } else {
      $('.home header').addClass("solid");
    }
}

function home_slider_height() {

  var window_width = $(window).width(),
      home_slider_content_height = $('.m__home-slider--slide-content').outerHeight() + 230;

  if(window_width < 700) {
    $('.m__home-slider--slide').css('height', home_slider_content_height);
  } else {
    $('.m__home-slider--slide').css('height', '630px');
  }
}

function image_content_overlay_height() {

  var window_width = $(window).width(),
      text_box_height = $('.m__image-content-overlay--text-box').outerHeight() + 140;

  if(window_width < 500) {
    $('.m__image-content-overlay').css('height', text_box_height);
  } else {
    $('.m__image-content-overlay').css('height', '530px');
  }
}

function init_map() {

  if($('body').hasClass('single-restaurants') || $('body').hasClass('single-tf_events') || $('body').hasClass('page-template-page-contact')) {

    var latitude = $('.google-map').attr('data-latitude'),
        longitude = $('.google-map').attr('data-longitude'),
        latlng = new google.maps.LatLng(latitude,longitude);

    var myStyles =[
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
    ];

    var mapOptions = {
      center: latlng,
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      styles: myStyles
    };

    var marker = new google.maps.Marker({
        position: latlng,
        map : map,
        icon: '/wp-content/themes/groupsite-2019/library/images/icons/map-pin.svg'
    });

    var mapClass = $('.google-map');
    var map = new google.maps.Map(mapClass[0],mapOptions);

    $('.zoom-in').click(function() {
      map.setZoom(map.getZoom() + 1);
    });

    $('.zoom-out').click(function() {
      map.setZoom(map.getZoom() - 1);
    });

    marker.setMap(map);
  }
}

function match_height() {

  $('.m__our-people-tile--content').matchHeight();
  $('.m__the-dish-list-tile--content').matchHeight();
  $('.m__whats-on-list-tile--content').matchHeight();
  $('.m__club-dandd-cta-tile').matchHeight();
  //$('.m__restaurant-list-tile').matchHeight();
}

function mobile_menu_toggle() {

  $('#mobile-navigation').click(function() {
    $('.c__mobile-menu').addClass('active');
  });

  $('#close-mobile').click(function() {
    $('.c__mobile-menu').removeClass('active');
  });
}

function newsletter_signup() {
    $('#newsletterform').submit(function(e) { // called by click, on auto submit or enter key

    $(".error").hide(); 
            
    var hasError = false;     
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/; 
    var nameReg = /^[\x00-\x7F]{3,32}$/;
    var numberonly = /^[0-9\s]{1,40}$/;
    var urlReg =  /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    var email = $("#email_address").val();        
    if(email == '') {       
      $("#email_address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');            
      hasError = true;        
    }         
    else if(!emailReg.test(email)) {            
      $("#email_address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');            
      hasError = true;        
    }   

    //gdpr
    if(document.getElementById('gdpr1').checked) {
      //do nothing
    } else {
      $("#gdpr1").after('<div class="error w-col w-col-12" style="padding-left: 40px; font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please tick to accept our privacy policy.</div>');            
      hasError = true;        
    }
    
    if(document.getElementById('gdpr2').checked) {
      //do nothing
    } else {
      $("#gdpr2").after('<div class="error w-col w-col-12" style="padding-left: 40px; font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please tick to receive newsletters.</div>');            
      hasError = true;        
    }           
            
    var captcha = grecaptcha.getResponse();
    var url = 'https://www.danddlondon.com/wp-content/themes/brandstyle1/recaptcha/check.php'; 
        
    if (captcha.length == 0 ) { 
      $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Complete the CAPTCHA.</div>'); 
      hasError = true; 
    } else if(hasError == false){// only check if validation is success to this point
      //whatever happens next -- need to always return false
      hasError = true; 
        
      $.ajax({
        url: url + "?captcha="+captcha,
        type: "POST",
        //data: (post_data),
        success: function (res) {
          if(res == 'error:captcha') {
            console.log('captcha failed');
            $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Captcha Failed. Try Again.</div>'); 
            hasError = true; 
          }
            
          if(res == 'error:secret key missing') {
            console.log('captcha failed - key missing');
            $('.g-recaptcha').after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Captcha Failed. Key Missing.</div>'); 
            hasError = true; 
          }             
            
          if(res == 'success:captcha') {
            //disable submit button
            $('#submittrigger').attr('disabled','disabled');
              
            actionURL = $('#newsletterform').attr('data-action');
            $('#g-recaptcha-response').remove(); //kill the response from Google so it's not sent to Maxemail
            submitdata = $('#newsletterform').serialize();

            $.ajax({
              url: actionURL,
              type: "POST",
              contentType: 'application/x-www-form-urlencoded', 
              crossDomain: true,
              data: (submitdata),
              complete: function(xmlHttp) {
                // response is 302 so can't pick up on that in JS
              },//complete
              error: function(xmlHttp) {
                // xmlHttp is a XMLHttpRquest object
                // response is 302 so can't pick up on that in JS
                // have to assume all is ok and display a thanks message
                $('#newsletterform').html('<p>Thank you for subscribing to our eNewsletter.</p>');
                calculate_body_height();
              }//complete                     
            });//ajax (second submit) 
                        
            //although there's no error returns false so HTML doesn't try and submit after JS triggered submit
            hasError = true; 
          }
        },//else error
        error : function(XMLHttpRequest, textStatus, errorThrown) {
          //alert("error: "+errorThrown, 0, "Error", "Error");
          console.log("error: "+errorThrown, 0, "Error", "Error");  
          hasError = true;                        
        }
      });//ajax 
    }//if captcha is not empty
  
    // Final test
    if(hasError == true) { 
      return false; //stop html submit
    }else{
      //do nothing and let html submit
    } // end if
  }); // submit form    
}

function owl_carousel() {

  $('.m__venue-tabs--testimonials .owl-carousel').owlCarousel({
    items: 1,
    smartSpeed: 500,
    loop: true,
    dots: false,
    mouseDrag: false,
    touchDrag: false,
  });

  $('.m__venue-tabs--testimonials .owl-navigation #prev').click(function() {
    $('.m__venue-tabs--testimonials .owl-carousel').trigger('prev.owl.carousel');
  });

  $('.m__venue-tabs--testimonials .owl-navigation #next').click(function() {
    $('.m__venue-tabs--testimonials .owl-carousel').trigger('next.owl.carousel');
  });

  $('.m__home-slider .owl-carousel').owlCarousel({
    animateOut: 'fadeOut',
    items: 1,
    smartSpeed: 700,
    loop: true,
    dots: false,
    autoplay: true,
    mouseDrag: false,
    touchDrag: false,
  });

  $('.m__home-slider .owl-navigation #prev').click(function() {
    $('.m__home-slider .owl-carousel').trigger('prev.owl.carousel');
  });

  $('.m__home-slider .owl-navigation #next').click(function() {
    $('.m__home-slider .owl-carousel').trigger('next.owl.carousel');
  });

  $('.m__venue-tabs--specs .owl-carousel').owlCarousel({
    animateOut: 'fadeOut',
    items: 1,
    smartSpeed: 700,
    loop: true,
    dots: false,
    autoplay: true,
    mouseDrag: false,
    touchDrag: false,
  });

  $('.m__venue-tabs--specs .owl-navigation #prev').click(function() {
    $('.m__venue-tabs--specs .owl-carousel').trigger('prev.owl.carousel');
  });

  $('.m__venue-tabs--specs .owl-navigation #next').click(function() {
    $('.m__venue-tabs--specs .owl-carousel').trigger('next.owl.carousel');
  });
}

function fade_in() {

  setTimeout(function() {
    $('body').css('opacity', '1');
  }, 300);
}

function parallax() {
 
 $(window).scroll(function() {    
        
  var scroll = $(window).scrollTop();
  var parallax_distance_slow = scroll / 6;
  var parallax_distance_medium = scroll / 5;
  var window_width = $(window).width();

    if(window_width > 700) {
      $('.parallax-object.vertical.slow').css('transform', 'translateY(-'+parallax_distance_slow+'px)');
      $('.parallax-object.vertical.medium').css('transform', 'translateY(-'+parallax_distance_medium+'px)');
    }

  });
}

function people_load_more() {

  $('.l__our-people--list--load-more').click(function() {

    var offset = $(this).attr('data-load'),
        count_posts = $(this).attr('data-count'),
        content = $('.l__our-people--list .row');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'people_load_more',
        query_offset : offset,   
      },
      success : function( response ) {
        content.append(response);
        update_offset();
        calculate_body_height();
      },
    });

    function update_offset() {
      offset = parseInt(offset) + 12;
      count_posts = parseInt(count_posts);

      if(offset > count_posts) {
        $('.l__our-people--list--load-more').css('display', 'none');
      } else {
        $('.l__our-people--list--load-more').attr('data-load', offset);
      }
    }
  });
}

function private_hire_filter() {

  $('.m__private-hire-filters .filter li').click(function() {

    if($(this).attr('filter-type') == 'location') {
      $('.m__private-hire-filters #location li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__private-hire-filters #location span').html($(this).html());
    }

    if($(this).attr('filter-type') == 'party-size') {
      $('.m__private-hire-filters #party-size li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__private-hire-filters #party-size span').html($(this).html());
    }

    if($(this).attr('filter-type') == 'outside-space') {
      $('.m__private-hire-filters #outside-space li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__private-hire-filters #outside-space span').html($(this).html());
    }

    var location = $('.m__private-hire-filters #location li.active').attr('data-id'),
        party_size = $('.m__private-hire-filters #party-size li.active').attr('data-id'),
        outside_space = $('.m__private-hire-filters #outside-space li.active').attr('data-id'), 
        private_hire_type = $('#private_hire_type').val(),
        content = $('.l__private-hire-list .row#tiles');

    $('.c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'private_hire_filter',
        query_location : location,
        query_party_size : party_size,
        query_outside_space : outside_space,
        query_private_hire_type : private_hire_type,      
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
          //content.removeClass('active');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function private_hire_filter_all() {

  $('.m__private-hire-filters #all').click(function() {

    $('.m__private-hire-filters #location span').html('Location');
    $('.m__private-hire-filters #party-size span').html('Party Size');
    $('.m__private-hire-filters #outside-space span').html('Outside Space');

    $('.c__loading--bar').removeClass('start-loading loading loaded');
    $('.m__private-hire-filters .filter li').removeClass('active');

    var private_hire_type = $('#private_hire_type').val(),
        content = $('.l__private-hire-list .row#tiles');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'private_hire_filter_all',
        query_private_hire_type : private_hire_type,
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
      },
    });
  });
}

function private_hire_filter_select() {

  $('.m__private-hire-filters .filter').click(function() {

    $(this).find('ul').toggleClass('active');
  });
}

function private_hire_form_submit() {
  
  $('#eventForm').submit(function() {
    $('.w-form-fail').hide();
    $('.w-form-done').hide();

    var hasError = false;
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var nameReg = /^[\x00-\x7F]{3,32}$/;
    var numberonly = /^[0-9\s]{1,40}$/;
    var urlReg = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    var name = $("#name").val();
    if (name == '') {
      $("#name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Name.</div>');
      hasError = true;
    } else if (!nameReg.test(name)) {
      $("#name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Name.</div>');
      hasError = true;
    }

    var surname = $("#surname").val();
    if (surname == '') {
      $("#surname").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Last Name.</div>');
      hasError = true;
    } else if (!nameReg.test(surname)) {
      $("#surname").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Last Name.</div>');
      hasError = true;
    }

    var telephone = $("#telephone").val();
    if (telephone == '') {
      $("#telephone").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Telephone Number.</div>');
      hasError = true;
    } else if (!nameReg.test(telephone)) {
      $("#telephone").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Telephone Number.</div>');
      hasError = true;
    }

    var email = $("#email").val();
    if (email == '') {
      $("#email").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');
      hasError = true;
    } else if (!emailReg.test(email)) {
      $("#email").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');
      hasError = true;
    }

    if (hasError == true) {
      return false; //stop html submit
    } else {
      var url = '/wp-content/themes/brandstyle1/mail/send.php';
      var datastring = $("#eventForm").serialize();
      $.ajax({
        type: 'POST',
        url: url,
        data: datastring,
        success: function (response) {

          if (response == 'sent') {

            //display the thanks message
            $('.w-form-done').show();

            //hide form
            $('#eventForm').hide();
            calculate_body_height();
            

          } else { // result <> OK
            //alert("no data");
            //display the fail message
            $('.w-form-fail').show();
          }

        }, //else error
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          //alert("error: "+errorThrown, 0, "Error", "Error");
          //display the fail message
          $('.w-form-fail').show();
        }
      });// end ajax read 

      //$('#formsubmittrigger').attr('value', 'Inquire Now'); // reset button text

      return false; //stop html submit

    }// end if

  }); // submit form 
}

function restaurant_filter() {

  $('#restaurants .m__restaurant-filter .filter li').click(function() {

    $('#restaurants .l__restaurant-list--tiles--load-more').css('display', 'none');

    var term = $(this).attr('data-id'),
        text = $(this).html(),
        content = $('#restaurants .l__restaurant-list--tiles .row');

    $('#restaurants .m__restaurant-filter #select span').html(text);
    $('#restaurants .c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'restaurant_type_filter',
        query_term : term,
      },
      beforeSend : function() {
        $('#restaurants .c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('#restaurants .c__loading--bar').addClass('loading');
       // content.removeClass('active');
      },
      success : function( response ) {
        $('#restaurants .c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function restaurant_filter_all() {

  $('#restaurants .m__restaurant-filter #all').click(function() {

    $('#restaurants .l__restaurant-list--tiles--load-more').css('display', 'none');

    var term = 'all',
        content = $('#restaurants .l__restaurant-list--tiles .row');

    $('#restaurants .m__restaurant-filter #select span').html('Please Select');
    $(this).find('ul').removeClass('active');
    $('#restaurants .c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'restaurant_type_filter',
        query_term : term,
      },
      beforeSend : function() {
        $('#restaurants .c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('#restaurants .c__loading--bar').addClass('loading');
        //content.removeClass('active');
      },
      success : function( response ) {
        $('#restaurants .c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function restaurant_filter_select() {

  $('#restaurants .m__restaurant-filter #select').click(function() {

    $(this).find('ul').toggleClass('active');
  });
}

function restaurant_load_more() {

  $('#restaurants .l__restaurant-list--tiles--load-more').click(function() {

    var offset = $(this).attr('data-load'),
        count_posts = $(this).attr('data-count'),
        content = $('#restaurants .l__restaurant-list--tiles .row');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'restaurant_load_more',
        query_offset : offset,   
      },
      success : function( response ) {
        content.append(response);
        update_offset();
        calculate_body_height();
        clickable_block();
      },
    });

    function update_offset() {
      offset = parseInt(offset) + 12;
      count_posts = parseInt(count_posts);

      if(offset > count_posts) {
        $('#restaurants .l__restaurant-list--tiles--load-more').css('display', 'none');
      } else {
        $('#restaurants .l__restaurant-list--tiles--load-more').attr('data-load', offset);
      }
    }
  });
}

function bars_filter() {

  $('#bars .m__restaurant-filter .filter li').click(function() {

    $('#bars .l__restaurant-list--tiles--load-more').css('display', 'none');

    var term = $(this).attr('data-id'),
        text = $(this).html(),
        content = $('#bars .l__restaurant-list--tiles .row');

    $('#bars .m__restaurant-filter #select span').html(text);
    $('#bars .c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'bar_type_filter',
        query_term : term,
      },
      beforeSend : function() {
        $('#bars .c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('#bars .c__loading--bar').addClass('loading');
       // content.removeClass('active');
      },
      success : function( response ) {
        $('#bars .c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function bars_filter_all() {

  $('#bars .m__restaurant-filter #all').click(function() {

    $('#bars .l__restaurant-list--tiles--load-more').css('display', 'none');

    var term = 'all',
        content = $('#bars .l__restaurant-list--tiles .row');

    $('#bars .m__restaurant-filter #select span').html('Please Select');
    $(this).find('ul').removeClass('active');
    $('#bars .c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'bar_type_filter',
        query_term : term,
      },
      beforeSend : function() {
        $('#bars .c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('#bars .c__loading--bar').addClass('loading');
        //content.removeClass('active');
      },
      success : function( response ) {
        $('#bars .c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function bars_filter_select() {

  $('#bars .m__restaurant-filter #select').click(function() {

    $(this).find('ul').toggleClass('active');
  });
}

function bar_scroll_to() {

  if($('body').hasClass('page-template-page-bars')) {

    $('html, body').animate({
      scrollTop: $("#bars").offset().top - 100
    }, 2000);
  }

  $('#scroll-to-bars').click(function() {

      $('html, body').animate({
          scrollTop: $("#bars").offset().top - 100
        }, 2000);
    });
}

function scroll_to() {

  $('#scroll-to').click(function () {
    var scroll_to_section = $(this).parents('section').next('section');
    $('html, body').animate({
      scrollTop: $(scroll_to_section).offset().top - 90
    }, 500);
  });
}

function select_fields() {

  $('.select-field').click(function() {
    $(this).find('ul').toggleClass('active');
    $(this).find('img').toggleClass('active');
  });

  $('.select-field li').click(function() {

    var name = $(this).attr('data-name'),
        value = $(this).attr('data-value'),
        action = $(this).attr('data-action'),
        text = $(this).html();

    $(this).parents('.select-field').find('span').html(text);

    $('input#'+name+'').val(value);

    if(action) {
      $('input#'+name+'').attr('data-action', action);
    }

  });
}

function title_position() {

  var window_width = $(window).width();

  var height;

  if(window_width > 500) {
    height = 130;
  } else {
    height = 60;
  }

  if($('.l__person-content h1').height() > 120) {
    $('.l__person-content h1').css('transform', 'translateY(25%)');
  } else {
    $('.l__person-content h1').css('transform', 'translateY(50%)');
  }

  if($('.m__single-private-hire-intro h1').height() > height) {
    $('.m__single-private-hire-intro h1').css('transform', 'translateY(-25%)');
  } else {
    $('.m__single-private-hire-intro h1').css('transform', 'translateY(-50%)');
  }

  if($('.m__competition-intro h1').height() > height) {
    $('.m__competition-intro h1').css('transform', 'translateY(-25%)');
  } else {
    $('.m__competition-intro h1').css('transform', 'translateY(-50%)');
  }
}

function the_dish_filter() {

  $('.m__the-dish-filter .filter li').click(function() {

    var term = $(this).attr('data-id'),
        text = $(this).html(),
        content = $('.l__the-dish-list--tiles .row');

    $('.m__the-dish-filter #select span').html(text);
    $('.c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'the_dish_type_filter',
        query_term : term,
      },
      beforeSend : function() {
        $('.c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
        //content.removeClass('active');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        match_height();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function the_dish_filter_all() {

  $('.m__the-dish-filter #all').click(function() {

    $('.m__the-dish-filter #select span').html('Please Select');
    $(this).find('ul').removeClass('active');
    $('.c__loading--bar').removeClass('start-loading loading loaded');

    var term = 'all',
        content = $('.l__the-dish-list--tiles .row');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'the_dish_type_filter',
        query_term : term,
      },
      beforeSend : function() {
        $('.c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
        //content.removeClass('active');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        match_height();
        //ajax_animate('.events-listing');
      },
    });
  });
}

function the_dish_filter_select() {

  $('.m__the-dish-filter #select').click(function() {

    $(this).find('ul').toggleClass('active');
  });
}

function the_dish_search() {

  $('.m__the-dish-filter #search-submit').click(function() {
    $('.c__loading--bar').removeClass('loading loaded');
    search_dish();
  });

  $('.m__the-dish-filter input').keypress(function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if(keycode == '13') {
      $('.c__loading--bar').removeClass('loading loaded');
      search_dish();
    }
  });

  function search_dish() {
    
    var search_term = $('.m__the-dish-filter input').val(),
        content = $('.l__the-dish-list--tiles .row');

    $('.c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'the_dish_search',
        query_term : search_term,
      },
      beforeSend : function() {
        $('.c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
        //content.removeClass('active');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
        //ajax_animate('.events-listing');
      },
    });
  }
}

function venue_tabs() {
  
  $('.m__inside-hero--filters li').click(function() {
    var id = $(this).attr('id');
    $('.m__inside-hero--filters li').removeClass('active');
    $(this).addClass('active');
    $('.tab').removeClass('active');
    $('#tab-'+id).addClass('active');
  });
}

function whats_on_filter() {

  $('.m__whats-on-filter .js-filter-whats-on li').click(function() {

    if($(this).attr('filter-type') == 'month') {
      $('.m__whats-on-filter #month li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__whats-on-filter #month span').html($(this).html());
    }

    if($(this).attr('filter-type') == 'event_type') {
      $('.m__whats-on-filter #event-type li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__whats-on-filter #event-type span').html($(this).html());
    }

    if($(this).attr('filter-type') == 'location') {
      $('.m__whats-on-filter #location li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__whats-on-filter #location span').html($(this).html());
    }

    var term = $('.m__whats-on-filter #event-type li.active').attr('data-id'), 
        date_start = $('.m__whats-on-filter #month li.active').attr('data-start'),
        date_end = $('.m__whats-on-filter #month li.active').attr('data-end'),
        location = $('.m__whats-on-filter #location li.active').attr('data-location'),
        content = $('.l__whats-on-list--tiles#upcoming .row');

    $('.c__loading--bar').removeClass('start-loading loading loaded');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'whats_on_filter',
        query_term : term,
        query_start : date_start,
        query_end : date_end,
        query_location : location,
      },
      beforeSend : function() {
        $('.c__loading--bar').addClass('start-loading');
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
          //content.removeClass('active');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        match_height();
        calculate_body_height();
        clickable_block();
        //ajax_animate('.events-listing');
      },
    });
  });


  $('.js-filter-campaign li').click(function() {

    var currentFilter = $(this).data('id');

    if($(this).attr('filter-type') == 'event_type') {
      $('.m__whats-on-filter #event-type li.active').removeClass('active');
      $(this).addClass('active');
      $('.m__whats-on-filter #event-type span').html($(this).html());
    }

    $('.m__whats-on-list-tile').each(function(x){
      $(this).hide();
      if($(this).data('cats').indexOf(currentFilter) !== -1){
        $(this).show();
      }
    });

  });

  $('.js-scrolling-filter-link').click(function(e){

    if($(this).data('filter-name') > ''){
       var currentFilter = $(this).data('filter-name');

      $('.m__whats-on-filter #event-type li.active').removeClass('active');
      $('.m__whats-on-filter #event-type li').each(function(){
        if($(this).data('id') == currentFilter){
          $(this).addClass('active');
          $('.m__whats-on-filter #event-type span').html($(this).html());
        }
      })
      $('.m__whats-on-list-tile').each(function(x){
        $(this).hide();
        if($(this).data('cats').indexOf(currentFilter) !== -1){
          $(this).show();
        }
      });
    }

  });

}

function whats_on_filter_all() {

  $('.m__whats-on-filter #all').click(function() {

    $('.m__whats-on-filter #month span').html('Month');
    $('.m__whats-on-filter #event-type span').html('Event Type');
    $('.m__whats-on-filter #location span').html('Location');
    $('.c__loading--bar').removeClass('start-loading loading loaded');
    $('.m__whats-on-filter .filter li').removeClass('active');
    $('.m__whats-on-list-tile').show();

    var content = $('.l__whats-on-list--tiles#upcoming .row');

    jQuery.ajax({
      type : 'post',
      url : '/wp-admin/admin-ajax.php',
      data : {
        action : 'whats_on_filter_all',
      },
      ajaxStart : function() {
        $('.c__loading--bar').addClass('loading');
      },
      success : function( response ) {
        $('.c__loading--bar').addClass('loaded');
        content.html( response );
        calculate_body_height();
        clickable_block();
      },
    });
  });
}

function whats_on_filter_select() {

  $('.m__whats-on-filter .filter').click(function() {

    $(this).find('ul').toggleClass('active');
  });
}


function campaign_landing_page_s_t_e() {
  // handle links with @href started with '#' only
  $(document).on('click', 'a[href^="#"]', function(e) {
    // target element id
    var id = $(this).attr('href');

    // target element
    var $id = $(id);
    if ($id.length === 0) {
      return;
    }

    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    // top position relative to the document
    var pos = $id.offset().top;

    // animated top scrolling
    $('body, html').animate({scrollTop: pos}, 2000);
  });
}

function homeHeroVideo(){

  //Uses https://github.com/rochestb/jQuery.YoutubeBackground
  if($('#js__home-youtube').length){
    $('#js__home-youtube').YTPlayer({
      videoId: $('#js__home-youtube').data('youtube-id'),
      playerVars: {
        modestbranding: 1,
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        branding: 0,
        rel: 0,
        autohide: 0,  
      },
      callback: function() {
        cbEvents();
      }
    });

    function cbEvents() {
      var player = $('#js__home-youtube').data('ytPlayer').player;

      $('.js__sound-toggle--youtube').on('click', function() {
        // Toggle video sound & icon img
        if (player.isMuted()) {
          player.unMute();
          $(this).addClass('sound-on');
        } else {
          player.mute();
          $(this).removeClass('sound-on');
        }
      })
    }

  }
  
  var videoFile = document.querySelector('.js-video-elem');

  if ( videoFile ) {
    videoFile.play

    var videoFileSoundToggle = document.querySelector('.js__sound-toggle--file');
    if ( videoFileSoundToggle ) {      
      videoFileSoundToggle.addEventListener('click', (e) => {
        e.preventDefault();
    
        if (videoFile.muted) {
          videoFile.muted = false; // Unmute the video
        } else {
          videoFile.muted = true; // Mute the video
        }
  
        videoFileSoundToggle.classList.toggle('sound-on');
      });
    }
  }

}

function book_club_form_submit() {

  $('#bookClubForm').submit(function() {
    $('.w-form-fail').hide();
    $('.w-form-done').hide();

    var hasError = false;
    var emailReg = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,8})$/;
    var nameReg = /^[\x00-\x7F]{3,32}$/;
    var numberonly = /^[0-9\s]{1,40}$/;
    var urlReg = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    var name = $("#name").val();
    if (name == '') {
      $("#name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Name.</div>');
      hasError = true;
    } else if (!nameReg.test(name)) {
      $("#name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Name.</div>');
      hasError = true;
    }

    var surname = $("#surname").val();
    if (surname == '') {
      $("#surname").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Last Name.</div>');
      hasError = true;
    } else if (!nameReg.test(surname)) {
      $("#surname").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Last Name.</div>');
      hasError = true;
    }

    var telephone = $("#telephone").val();
    if (telephone == '') {
      $("#telephone").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Telephone Number.</div>');
      hasError = true;
    } else if (!nameReg.test(telephone)) {
      $("#telephone").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Telephone Number.</div>');
      hasError = true;
    }

    var email = $("#email").val();
    $('input[name="email_address"]').val(email);
    if (email == '') {
      $("#email").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Email Address</div>');
      hasError = true;
    } else if (!emailReg.test(email)) {
      $("#email").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Email Address.</div>');
      hasError = true;
    }

    var address = $("#address").val();
    if (address == '') {
      $("#address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Address</div>');
      hasError = true;
    } else if (!nameReg.test(address)) {
      $("#address").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Address.</div>');
      hasError = true;
    }

    var postcode = $("#postcode").val();
    if (postcode == '') {
      $("#postcode").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Postcode</div>');
      hasError = true;
    } else if (!nameReg.test(postcode)) {
      $("#postcode").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Postcode.</div>');
      hasError = true;
    }

    var companyName = $("#company-name").val();
    if (companyName == '') {
      $("#company-name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Company Name</div>');
      hasError = true;
    } else if (!nameReg.test(companyName)) {
      $("#company-name").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Company Name.</div>');
      hasError = true;
    }

    var jobtitle = $("#job-title").val();
    if (jobtitle == '') {
      $("#job-title").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Job Title</div>');
      hasError = true;
    } else if (!nameReg.test(jobtitle)) {
      $("#job-title").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Job Title.</div>');
      hasError = true;
    }

    var dob = $("#dob").val();
    if (dob == '') {
      $("#dob").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Please enter your Date Of Birth</div>');
      hasError = true;
    } else if (!nameReg.test(dob)) {
      $("#dob").after('<div class="error" style="font-size:11px; color:#ff0000; display:block;"><span class="icon-remove"></span> Enter a valid Date Of Birth.</div>');
      hasError = true;
    }

    if (hasError == true) {
      console.log('has error');

      return false; //stop html submit
    } else {
      console.log('no error');
      var url = '/wp-content/themes/brandstyle1/mail/send.php';
      var datastring = $("#bookClubForm").serialize();
      $.ajax({
        type: 'POST',
        url: url,
        data: datastring,
        beforeSend: function() {
          $('#formsubmittrigger').prop('disabled', true);
        },
        success: function (response) {
          console.log('response ' + response);

          if (response.includes('sent')) {

            //display the thanks message
            $('.w-form-done').show();

            //hide form
            $('#bookClubForm').hide();
            calculate_body_height();


          } else { // result <> OK
            //alert("no data");
            //display the fail message
            $('.w-form-fail').show();
            $('#formsubmittrigger').prop('disabled', false);
          }

        }, //else error
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          //alert("error: "+errorThrown, 0, "Error", "Error");
          //display the fail message
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
          $('.w-form-fail').show();
          $('#formsubmittrigger').prop('disabled', false);
        }
      });// end ajax read

      //$('#formsubmittrigger').attr('value', 'Inquire Now'); // reset button text

      return false; //stop html submit

    }// end if

  }); // submit form
}

function campaignPageCustomFilters() {
  if ($('.l__campaign-tiles__filter').length) {
    $('.js__filter-campaign-tiles').on('click', function(e) {
      e.preventDefault();

      $(this).siblings().removeClass('current');
      $(this).addClass('current');

      const filterGroup = $(this).data('filter-group');
      if (filterGroup == 'all') {
        $('.campaign-tile-outer').show();
      } else {
        const tilesToShow = $('.campaign-tile-outer[data-filter-group="' + filterGroup + '"]');
        if (! tilesToShow.length) {
          $('.campaign-tile-outer').hide();
          $('.js__no-campaigns-found').show();
        } else {
          $('.campaign-tile-outer').hide();
          $('.campaign-tile-outer[data-filter-group="' + filterGroup + '"').show();
        }
      }

      calculate_body_height();
    })
  }
}
function club_page_function() {
  if ( document.body.classList.contains('page-template-page-club-dandd') ) {
    // Booking Trigger
    const bookingTriggers = document.querySelectorAll('.js-club-booking-trigger');
    if ( bookingTriggers ) {
      bookingTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          document.querySelector('.c__booking-widget').classList.add('active');
        });
      });
    }

    // Perks
    const perkTriggers = document.querySelectorAll('.js-club-perk-btn');
    if ( perkTriggers ) {
      perkTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          // Set the height of the parent element
          const parentElems = trigger.closest('.tiers__options').querySelectorAll('.tiers__option');
          parentElems.forEach(elem => {
            elem.style.height = trigger.closest('.tiers__option').clientHeight + 'px';
          });

          trigger.closest('.tiers__option').classList.toggle('active');

          trigger.innerHTML = trigger.innerHTML === 'Perks' ? 'Close' : 'Perks';
        });
      });
    }

    // FAQs
    const faqsTrigger = document.querySelector('.js-club-faqs-trigger');
    const faqsContent = document.querySelector('.js-club-faqs-content');
    if ( faqsTrigger && faqsContent ) {
      faqsTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        
        faqsTrigger.classList.toggle('open');
        $('.js-club-faqs-content').slideToggle(() => {
          calculate_body_height();
        });
      });
    }

    // Terms and Conditions
    const termsTrigger = document.querySelector('.js-club-terms-trigger');
    const termsContent = document.querySelector('.js-club-terms-content');
    if ( termsTrigger && termsContent ) {
      termsTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        
        termsTrigger.classList.toggle('open');
        $('.js-club-terms-content').slideToggle(() => {
          calculate_body_height();
        });
      });
    }
  }
}



function init() {
  apprenticeship_form_submit();
  booking_widget();
  booking_widget_toggle();
  clickable_block();
  competition_signup();
  book_club_signup();
  form_accordion();
  header_adjust();
  header_switch();
  homepage_header_transition();
  home_slider_height();
  init_map();
  image_content_overlay_height();
  match_height();
  mobile_menu_toggle();
  newsletter_signup();
  owl_carousel();
  parallax();
  people_load_more();
  private_hire_filter();
  private_hire_filter_all();
  private_hire_filter_select();
  private_hire_form_submit();
  restaurant_filter();
  restaurant_filter_all();
  restaurant_filter_select();
  restaurant_load_more();
  bars_filter();
  bars_filter_all();
  bars_filter_select();
  bar_scroll_to();
  scroll_to();
  select_fields();
  title_position();
  the_dish_filter();
  the_dish_filter_all();
  the_dish_filter_select();
  the_dish_search();
	venue_tabs();
  whats_on_filter();
  whats_on_filter_all();
  whats_on_filter_select();
  campaign_landing_page_s_t_e();
  book_club_form_submit();
  homeHeroVideo();
  campaignPageCustomFilters();
  club_page_function();
}

function window_load() {
  calculate_body_height();
  fade_in();
}

function resize() {
  calculate_body_height();
  header_adjust();
  header_switch();
  homepage_header_transition();
  home_slider_height();
  image_content_overlay_height();
  parallax();
  title_position();
}